// extracted by mini-css-extract-plugin
export default {"root":"promo_codes_root__PKzcv","actions_link":"promo_codes_actions_link__xMeVx","action_link_text":"promo_codes_action_link_text__tX3sz","tag":"promo_codes_tag__7Tm5h"};